type PopupOptions = {
  width?: number;
  height?: number;
};

export function openMetaOAuthPopup(url: string, name: string, options: PopupOptions = {}) {
  const width = options.width ?? 620;
  const height = options.height ?? 760;
  const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2);
  const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2);

  const popup = window.open(
    url,
    name,
    [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      "scrollbars=yes",
      "resizable=yes",
      "toolbar=no",
      "location=no",
      "menubar=no",
      "status=no",
    ].join(",")
  );

  popup?.focus();
  return popup;
}
